import React from "react";
import { RotateCcw } from "lucide-react";
import { Button } from "./ui/button";

export class TreeErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, key: 0 };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[FamilyTree] canvas crashed:", error, info?.componentStack);
  }

  reload = () => this.setState((s) => ({ error: null, key: s.key + 1 }));

  render() {
    if (this.state.error) {
      return (
        <div data-testid="tree-error-card" className="flex h-full w-full items-center justify-center bg-[#F4F6F8] p-6">
          <div className="w-full max-w-sm rounded-2xl border border-[#D8E0E8] bg-white p-6 text-center shadow-md">
            <h3 className="text-base font-semibold text-[#082D4A] md:text-lg">Something went wrong drawing your tree</h3>
            <p className="mt-2 text-sm text-[#64748B]">Your family data is safe. Reload the tree to pick up where you left off.</p>
            <Button data-testid="tree-reload-button" onClick={this.reload} className="mt-4 bg-[#082D4A] text-white hover:bg-[#08223A]">
              <RotateCcw size={14} className="mr-1.5" /> Reload tree
            </Button>
          </div>
        </div>
      );
    }
    return <React.Fragment key={this.state.key}>{this.props.children}</React.Fragment>;
  }
}
